"use strict";
// TODO: THIS FILE MIGHT ACTUALLY BE UNUSED
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Charts = void 0;
var grouping_1 = require("./grouping");
var jquery_1 = __importDefault(require("jquery"));
var underscore_1 = __importDefault(require("underscore"));
var adaptiveCharts_1 = require("./adaptiveCharts");
var util_1 = require("./utils/util");
var howImportantXscales = [
    'Inte alls viktigt',
    'Inte särskilt viktigt',
    'Viss betydelse',
    'Viktigt',
    'Mycket viktigt',
    'Helt avgörande',
    'Vet ej'
];
exports.Charts = {
    additionalParameters: {
        _importanceCharts: {
            kind: 'InDepthSurveyQuestions',
            percentage: true,
            xscale: howImportantXscales,
            year: 2012
        },
        amount_of_business: {
            xscale: [
                'Ingen anställd',
                'Minst en anställd',
                'Totalt antal företag',
            ]
        },
        amount_of_business_absolute: {
            xscale: [
                'Ingen anställd',
                'Minst en anställd',
                'Totalt antal företag',
            ],
            kind: 'InDepthSurveyQuestions',
            year: 2018,
            datadesc: [{ legend: 'Totalt antal företag' }]
        },
        business_climate_change_5_years: {
            kind: 'SurveySimpleBarchart',
            year: 2018,
            title: 'Hur har företagsklimatet förändrats de senaste 5 åren?'
        },
        municipality_runs_competing_businesses: {
            kind: 'SurveySimpleBarchart',
            year: 2018,
            title: 'Bedriver din kommun verksamhet som ditt företag skulle vilja utföra?'
        },
        survey_contact_understanding: {
            kind: 'SurveySimpleBarchart',
        },
        survey_contact_clearfee: {
            kind: 'SurveySimpleBarchart',
        },
        survey_contact_handling: {
            kind: 'SurveySimpleBarchart',
        },
        survey_contact_reachable: {
            kind: 'SurveySimpleBarchart',
        },
        survey_contact_digitized: {
            kind: 'SurveySimpleBarchart',
        },
        contracting: {
            dontPassXscale: true
        },
        entrepreneurship: {
            xscale: [
                'Andel företagsamma individer',
                'Företagsamma unga',
                'Företagsamma kvinnor'
            ]
        },
        young_entrepreneurs: {
            kind: 'InDepthSurveyQuestions',
            year: 2018,
            dontPassXscale: true,
            excludeSweden: true
        },
        global_trade_per_capita: {
            dontPassXscale: true
        },
        jobs_per_business: {
            kind: 'InDepthSurveyQuestions',
            dontPassXscale: true,
            percentage: false,
            year: 2016
        },
        largest_employers: {
            kind: 'LargestEmployers',
            excludeAverage: true,
            passMuniInsteadOfKommun: true,
            year: 2018,
            datadesc: [{ legend: 'Procentuell andel av totalt antal anställda i kommunen' }]
        },
        largest_private_employers: {
            kind: 'LargestEmployers',
            excludeAverage: true,
            passMuniInsteadOfKommun: true,
            year: 2018,
            datadesc: [{ legend: 'Procentuell andel av totalt antal anställda i kommunen' }]
        },
        most_prioritized_actions: {
            kind: 'SurveySimpleBarchart',
            title: 'Vilka åtgärder bör kommunen prioritera?'
        },
        knowledge_of_muni_work: {
            kind: 'SurveySimpleBarchart',
            year: 2016,
            factor: 'Känner du att du har kunskap om hur kommunen arbetar för att förbättra företagsklimatet?',
            title: 'Kunskap om kommunens arbete'
        },
        muni_contact_latest_year: {
            kind: 'InDepthSurveyQuestions',
            dontPassXscale: true,
            percentage: true,
        },
        muni_contact_latest_year_about: {
            kind: 'InDepthSurveyQuestions',
            dontPassXscale: true,
            percentage: true,
        },
        muni_contact_hesitate: {
            kind: 'InDepthSurveyQuestions',
            dontPassXscale: true,
            percentage: true,
        },
        company_education_contact: {
            kind: 'InDepthSurveyQuestions',
            dontPassXscale: true,
            percentage: true,
            year: 2023,
        },
        advice_on_permission: {
            kind: 'SurveySimpleBarchart',
            dontPassXscale: true,
            percentage: true,
            year: 2018,
            title: 'Vägledning vid tillståndsgivning, tillsyn eller kontroll?'
        },
        net_costs: {
            kind: 'InDepthSurveyQuestions',
            dontPassXscale: true,
            year: 2017,
            percentage: false,
            datadesc: [{ legend: 'kr' }]
        },
        crime_change_2years: {
            kind: 'SurveySimpleBarchart',
            dontPassXscale: true,
            percentage: true,
            year: 2017,
            title: 'Hur har brottsligheten mot företag förändrats i din kommun de senaste två åren?'
        },
        crime_a_problem: {
            kind: 'SurveySimpleBarchart',
            dontPassXscale: true,
            percentage: true,
            year: 2017,
            title: 'Är brottsligheten ett problem för företagen?'
        },
        crime_risk_kind: {
            kind: 'SurveySimpleBarchart',
            dontPassXscale: true,
            percentage: true,
            year: 2017,
            title: 'Vilka brottstyper bedömer du att det är hög risk att drabbas av?'
        },
        company_relocate: {
            kind: 'SurveySimpleBarchart',
            dontPassXscale: true,
            percentage: true,
            year: 2024,
            title: 'Har du övervägt att flytta företaget?'
        },
        net_population_change: {
            excludeAverage: true,
            excludeType: true,
            disallowDecimals: true,
            xscale: ["Ålder 15-24", "Ålder 25-34"],
            zeroCenter: true
        },
        new_entrepreneurship: {
            xscale: [
                'Antal nyföretagsamma individer',
                'Nyföretagsamma unga',
                'Nyföretagsamma kvinnor'
            ]
        },
        retirees: {
            year: [2010, 2022],
            xscale: ["Kvot 65+/19-64", "Kvot 80+/19-64"]
        },
        type_of_business: {
            kind: 'InDepthSurveyQuestions',
            dontPassXscale: true,
            percentage: true,
        },
        unemployment: {
            dontPassXscale: true
        }
    },
    chartHeight: {
        DEFAULT: 600,
        largest_private_employers: 1.33,
        jobs_per_business: 1.33,
        largest_employers: 1.33
    },
    importanceCharts: [
        'how_important_for_company_relevant_highshool_programs',
        'how_important_for_company_company_trainee_positions',
        'how_important_for_company_relevant_skilled_workers_programs',
        'how_important_for_company_relevant_higher_education',
        'how_important_for_company_targeted_adult_education',
        'how_important_for_company_summer_jobs',
        'how_important_for_company_work_experience',
        'how_important_for_muni_housing',
        'how_important_for_muni_entrepreneurial_climate',
        'how_important_for_muni_more_companies',
        'how_important_for_muni_pop_moving_in',
        'how_important_for_muni_youth_staying',
        'how_important_for_muni_quality_education',
        'how_important_for_muni_competent_workers',
        'how_important_for_muni_diverse_entrepreneurial_climate'
    ],
    inDepthTooltipFormatter: function () {
        // @ts-ignore - highcharts missing, will be removed
        return Math.round(this.y * 100.0) / 100.0 + "% (" + this.series.name + ": " + this.x + ")";
    },
    apiParams: function (municipalities, factor, type, subseries, options) {
        var _a, _b;
        if (options === void 0) { options = {}; }
        municipalities = (options === null || options === void 0 ? void 0 : options.excludeSweden) ? municipalities : underscore_1.default.flatten(['Sverige'].concat(municipalities));
        municipalities = underscore_1.default.uniq(municipalities);
        var query = {
            kommun: municipalities,
            factor: window.factorAPINames[factor],
            type: type,
            xscale: subseries,
        };
        options = {};
        var kind = 'MunicipalityFactorValues';
        var additional = undefined;
        // @ts-ignore
        if (this.additionalParameters[factor]) {
            // @ts-ignore
            additional = this.additionalParameters[factor];
        }
        else if (underscore_1.default(this.importanceCharts).includes(factor)) {
            additional = this.additionalParameters['_importanceCharts'];
        }
        if (additional) {
            if (additional.factor) {
                query.factor = additional.factor;
            }
            if (additional.excludeType) {
                delete query.type;
            }
            if (!!(window === null || window === void 0 ? void 0 : window.fromSwedenStatisticsPage)) {
                if (additional.excludeAverage) {
                    query.kommun = (_a = query.kommun) === null || _a === void 0 ? void 0 : _a.slice(1);
                }
            }
            if (additional.xscale) {
                query.xscale = additional.xscale;
            }
            if (additional.dontPassXscale) {
                delete query.xscale;
            }
            if (additional.year) {
                query.year = additional.year;
            }
            if (!!additional.percentage) {
                query.percentage = additional.percentage;
            }
            if (additional.passMuniInsteadOfKommun) {
                query.muni = query.kommun;
                delete query.kommun;
            }
            if (additional.excludeSweden) {
                var counties = underscore_1.default.chain(municipalities)
                    .map(function (muni) { return grouping_1.Grouping.countyFor(muni); })
                    .filter(function (c) { return !!c; })
                    .map(function (c) { return c === null || c === void 0 ? void 0 : c.name; })
                    .value();
                query.kommun = underscore_1.default.flatten(['Sverige'].concat(counties).concat(municipalities));
                query.kommun = underscore_1.default.uniq(query.kommun);
            }
            if (additional.disallowDecimals) {
                options.xAxis = { allowDecimals: false };
            }
            if (additional.title) {
                options.title = additional.title;
            }
            if (additional.datadesc) {
                options.datadesc = additional.datadesc;
            }
            if (additional.tickInterval) {
                if (!options.xAxis) {
                    options.xAxis = {};
                }
                options.xAxis.tickInterval = additional.tickInterval;
            }
            if (additional.zeroCenter) {
                if (!options.yAxis) {
                    options.yAxis = {};
                }
                options.yAxis.zeroCenter = additional.zeroCenter;
            }
            if (additional.yAxisText) {
                if (!options.yAxis) {
                    options.yAxis = {};
                }
                options.yAxis = {
                    title: {
                        text: additional.yAxisText
                    }
                };
            }
            kind = (_b = additional.kind) !== null && _b !== void 0 ? _b : kind;
            if (additional.kind === this.additionalParameters.largest_employers.kind && ((query === null || query === void 0 ? void 0 : query.muni) || []).length > 1) {
                // if multiple munis, assume we don't want to see 'Sverige'
                query.muni = underscore_1.default.filter((query === null || query === void 0 ? void 0 : query.muni) || [], function (k) { return k !== 'Sverige'; });
            }
        }
        return [kind, query, options];
    },
    drawBigChart: function (targetId, municipalities, factor, type, subseries, optionsParam) {
        subseries = util_1.toStringArray(subseries);
        var _a = this.apiParams(municipalities, factor, type, subseries, optionsParam), kind = _a[0], query = _a[1], options = _a[2];
        var chartContainer = jquery_1.default("#" + targetId);
        var adaptive = {
            container: chartContainer,
            height: chartContainer.data('height') || this.chartHeight.DEFAULT,
            // @ts-ignore - I guess we'll have to draw a line somewhere...
            factor: this.chartHeight[factor]
        };
        options.animate = true;
        options.theme = 'fklimat-big';
        options = jquery_1.default.extend(true, options, optionsParam);
        var callback = (function () { });
        // @ts-ignore - Some really ugly piggy backing stuff going on here. Just suppressing it for now.
        callback.showlegend = true;
        if ((kind === 'InDepthSurveyQuestions') && query.percentage) {
            // @ts-ignore - Some really ugly piggy backing stuff going on here. Just suppressing it for now.
            callback.tooltipformatter = this.inDepthTooltipFormatter;
        }
        return adaptiveCharts_1.Fklimat.renderTo(targetId, kind, query, callback, options, adaptive);
    }
};
jquery_1.default(function () {
    if (!window.Artilect) {
        return;
    }
    return Artilect.themes.mobile = {
        highcharts: {
            colors: ['#aeaeae', '#57758d',
                '#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572',
                '#FF9655', '#FFF263', '#6AF9C4'],
            chart: {
                backgroundColor: 'white',
                spacingLeft: 0
            },
            exporting: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            plotOptions: {
                line: {
                    lineWidth: 5,
                    marker: {
                        radius: 8,
                        symbol: 'circle'
                    },
                    states: {
                        hover: {
                            lineWidth: 7
                        }
                    }
                }
            },
            xAxis: {
                lineColor: '#cccccc',
                tickColor: '#cccccc',
                tickInterval: 2,
                tickPosition: 'inside',
                labels: {
                    overflow: 'justify',
                    style: {
                        color: '#9a9a9a'
                    }
                }
            },
            yAxis: {
                gridLineColor: '#cccccc',
                style: {
                    marginRight: '5px'
                }
            },
            title: {
                align: 'left',
                margin: 30,
                y: 15,
                style: {
                    color: '#000',
                    font: 'bold 16px "Neo Sans", Verdana, sans-serif',
                    lineHeight: '20px'
                }
            },
            subtitle: {
                enabled: 'false',
                text: '',
                style: {
                    display: 'none'
                }
            },
            legend: {
                align: 'center',
                backgroundColor: '#ededed',
                borderRadius: 1,
                padding: 13,
                borderWidth: 0,
                margin: 20,
                itemMarginTop: 0,
                itemDistance: 19,
                lineHeight: 14,
                itemStyle: {
                    font: '14px "Neo Sans"',
                    lineHeight: '16px',
                    textTransform: 'uppercase',
                    color: '#57758d'
                },
                itemHoverStyle: {
                    color: '#33414e'
                }
            }
        }
    };
});
